/**
 * Returns the allowed calculation code options for an On Call day, given the
 * server-determined default code for that day.
 *
 * - Weekday (default "1") may be a half shift: [0.5, 1]
 * - Weekend/holiday (default "2") may be a single shift: [1, 2]
 * - null (not a coded day) returns []
 * - Unknown defaults collapse to a single fixed option.
 *
 * Options are returned in ascending order. The dropdown's initial selected
 * value is controlled by the Select's `value` prop, not by array order.
 */
export const getCalculationCodeOptions = (defaultCode: string | null): number[] => {
  if (defaultCode === null) return []

  const numericDefault = Number(defaultCode)
  switch (defaultCode) {
    case '1':
      return [0.5, 1]
    case '2':
      return [1, 2]
    default:
      return [numericDefault]
  }
}
